import axios from "axios";

export const sendMail = async (data) => {
  try {
    const res = await axios.post("/send-mail", data, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return res;
  } catch (e) {
    return "Error sending message";
  }
};

export const sendPlanInquiryMail = async ({ name, email, plan }) => {
  try {
    const res = await axios.post("/send-plan-inquiry", { name, email, plan });
    return res;
  } catch (error) {
    console.log("🚀 ~ sendPlanInquiryMail ~ error:", error);
    throw error?.response?.data?.message || "Error sending inquiry";
  }
};
